import { Injectable } from '@angular/core';
import { Manager } from '../../manager.service';

@Injectable({
  providedIn: 'root'
})
export class ApiClientService<T extends {id: string}> extends Manager<T> {
}
